// Field schema for the **package-deal** extraction specialist.
//
// Hard-coded source of truth for the structured payload the packages specialist
// emits. The AI Tooling page seeds the json_schema from this; the backend
// resolves the live config from ai_tooling/packages-reader at call time.
//
// Sibling files:
// - ./packages-parameters.js — prompts that drive the specialist
// - ./accommodation-schema.js, ./green-fees-schema.js — the parallel specialists

export const PACKAGES_FIELD_JSON_SCHEMA_NAME = "supplier_packages_extraction"

export const PACKAGES_FIELD_JSON_SCHEMA = {
	type: "object",
	additionalProperties: false,
	properties: {
		extraction_id: { type: "string" },
		extracted_at: { type: "string" },
		package_lines: {
			type: "array",
			items: {
				type: "object",
				additionalProperties: false,
				properties: {
					name: { type: "string" },
					nights: { type: "number" },
					rounds_included: { type: "number" },
					board_basis: {
						type: ["string", "null"],
						enum: ["RO", "BB", "HB", "FB", "AI", "UAI", null],
					},
					room_category: {
						type: "string",
						enum: [
							"Single",
							"Twin",
							"Double",
							"Triple",
							"Quad",
							"Suite",
							"Studio",
							"Apartment",
							"Villa",
							"Other",
						],
					},
					room_type_label: { type: ["string", "null"] },
					courses_included: { type: "array", items: { type: "string" } },
					occupancy: { type: "number" },
					price_native: { type: "number" },
					currency: { type: "string" },
					price_basis: {
						type: "string",
						enum: ["per_person", "per_package"],
					},
					period: {
						type: "object",
						additionalProperties: false,
						properties: {
							start: { type: "string" },
							end: { type: "string" },
						},
						required: ["start", "end"],
					},
					month_set: {
						type: "array",
						items: { type: "number", minimum: 1, maximum: 12 },
					},
					inclusions: { type: "array", items: { type: "string" } },
					notes: { type: ["string", "null"] },
				},
				required: [
					"name",
					"nights",
					"rounds_included",
					"board_basis",
					"room_category",
					"room_type_label",
					"courses_included",
					"occupancy",
					"price_native",
					"currency",
					"price_basis",
					"period",
					"month_set",
					"inclusions",
					"notes",
				],
			},
		},
		package_supplements: {
			type: "array",
			items: {
				type: "object",
				additionalProperties: false,
				properties: {
					kind: {
						type: "string",
						enum: [
							"single_supplement",
							"extra_night",
							"extra_round",
							"board_upgrade",
							"buggy",
							"other",
						],
					},
					applies_to: { type: "array", items: { type: "string" } },
					value_native: { type: ["number", "null"] },
					value_pct: { type: ["number", "null"] },
					currency: { type: ["string", "null"] },
					basis: {
						type: "string",
						enum: ["per_person", "per_night", "per_round", "per_stay", "fixed"],
					},
					period: {
						type: ["object", "null"],
						additionalProperties: false,
						properties: {
							start: { type: ["string", "null"] },
							end: { type: ["string", "null"] },
						},
						required: ["start", "end"],
					},
					notes: { type: ["string", "null"] },
				},
				required: [
					"kind",
					"applies_to",
					"value_native",
					"value_pct",
					"currency",
					"basis",
					"period",
					"notes",
				],
			},
		},
		agent_metadata: {
			type: "object",
			additionalProperties: false,
			properties: {
				confidence_score: { type: "number", minimum: 0, maximum: 1 },
				reasoning: { type: "string" },
			},
			required: ["confidence_score", "reasoning"],
		},
	},
	required: [
		"extraction_id",
		"extracted_at",
		"package_lines",
		"package_supplements",
		"agent_metadata",
	],
}
